import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const occurrenceDurationStatistics: Partial<Record<keyof TComponentValue<'AlarmStatistics'>['occurrenceDurationStatistics'], string>> = {
  count: 'Przelicz',
  sum: 'Całkowity czas trwania',
  average: 'Średni czas trwania',
  median: 'Mediana czasu trwania',
};

export default {
  showAlarmWithoutOccurrences: 'Pokaż wszystkie alarmy',
  occurrenceDurationStatistics,
};
